<template>
  <pt-detection-corpus-structure-table class="pt-detection-corpus-structure-table__withData" ref="table" :request-data="getDataList" :page-size="pageSize"
  :total-number="Number(totalNumber)" :table-data="tableData" :category="category" :tableLabels="tableLabels">
    <template slot-scope="scope">
      <slot :row="scope.row"></slot>
    </template>
  </pt-detection-corpus-structure-table>
</template>

<script>
import PtDetectionCorpusStructureTable from './index'
export default {
  name: 'pt-detection-corpus-structure-table__withData',
  components: {
    'pt-detection-corpus-structure-table': PtDetectionCorpusStructureTable
  },
  data () {
    return {
      pageSize: 10,
      totalNumber: 0,
      tableData: [],
      currentParams: {}
    }
  },
  props: {
    category: {
      type: String,
      default: ''
    },
    tableLabels: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    category (val, old) {
      this.$refs.table.reload()
    }
  },
  methods: {
    buildFilterParams (page, params = {}) {
      if (Object.keys(params).length) {
        params['page'] = page
        params['size'] = this.pageSize
        params['sort'] = 'id,desc'
        return params
      } else {
        return {
          page: page,
          size: this.pageSize,
          sort: 'id,desc'
        }
      }
    },
    getDataList (page, next) {
      // let data = {
      //   status: this.status.split(','),
      //   pageable: { page: page, size: this.pageSize, sort: ['createdDate,asc'] }
      // }
      let data = this.buildFilterParams(page, this.currentParams)
      this.$store.dispatch('getCorpusStructureListByType', data).then(res => {
        next(res.data)
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        this.$emit('getAllSize', this.totalNumber)
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err)
      })
    },
    // 筛选数据的参数,不传默认为{}
    reload (params = {}) {
      this.currentParams = params
      this.$refs.table.reload()
    }
  }
}
</script>
